import {
  EXTERNAL_API_LOAD_EXTERNAL_API_BEGIN,
  EXTERNAL_API_LOAD_EXTERNAL_API_SUCCESS,
  EXTERNAL_API_LOAD_EXTERNAL_API_FAILURE,
  EXTERNAL_API_LOAD_EXTERNAL_API_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadExternalApi(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EXTERNAL_API_LOAD_EXTERNAL_API_BEGIN,
    });

    const { projectId, version, externalApiId } = args;
    let header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/${externalApiId}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EXTERNAL_API_LOAD_EXTERNAL_API_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EXTERNAL_API_LOAD_EXTERNAL_API_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadExternalApiError() {
  return {
    type: EXTERNAL_API_LOAD_EXTERNAL_API_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EXTERNAL_API_LOAD_EXTERNAL_API_BEGIN:
      return {
        ...state,
        loadExternalApiPending: true,
        loadExternalApiError: null,
      };

    case EXTERNAL_API_LOAD_EXTERNAL_API_SUCCESS:
      return {
        ...state,
        loadExternalApiPending: false,
        loadExternalApiError: null,
        externalApiData: action.data ? action.data : null,
      };

    case EXTERNAL_API_LOAD_EXTERNAL_API_FAILURE:
      return {
        ...state,
        loadExternalApiPending: false,
        loadExternalApiError: action.data.error,
      };

    case EXTERNAL_API_LOAD_EXTERNAL_API_DISMISS_ERROR:
      return {
        ...state,
        loadExternalApiError: null,
      };

    default:
      return state;
  }
}
